import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId } from "react";
import { cn } from "../utils";
import type { HoldingShapeProps } from "./holding-shape.types";
import { pathMap, CLIP_PATH_SCALE } from "./paths";
const HoldingShape = React.forwardRef<HTMLDivElement, HoldingShapeProps>((t0, ref) => {
  const $ = _c(25);
  let children;
  let className;
  let props;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      scale: t1,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    variant = $[5];
  }
  const scale = t1 === undefined ? 1 : t1;
  const clipId = useId();
  const path = pathMap[variant];
  const offset = (1 - scale) / 2;
  const transform = `translate(${offset} ${offset}) scale(${CLIP_PATH_SCALE * scale})`;
  let t2;
  if ($[6] !== className) {
    t2 = cn("relative aspect-square", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== path || $[9] !== transform) {
    t3 = <path d={path} transform={transform} />;
    $[8] = path;
    $[9] = transform;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== clipId || $[12] !== t3) {
    t4 = <svg width="0" height="0" className="absolute" aria-hidden="true"><defs><clipPath id={clipId} clipPathUnits="objectBoundingBox">{t3}</clipPath></defs></svg>;
    $[11] = clipId;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = `url(#${clipId})`;
  let t6;
  if ($[14] !== t5) {
    t6 = {
      clipPath: t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== children || $[17] !== t6) {
    t7 = <div className="h-full w-full overflow-hidden" style={t6}>{children}</div>;
    $[16] = children;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== props || $[20] !== ref || $[21] !== t2 || $[22] !== t4 || $[23] !== t7) {
    t8 = <div ref={ref} data-slot="holding-shape" className={t2} {...props}>{t4}{t7}</div>;
    $[19] = props;
    $[20] = ref;
    $[21] = t2;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
});
HoldingShape.displayName = "HoldingShape";
export { HoldingShape };